import { useForm } from 'react-final-form';
import { useAppSelector } from 'helpers/hooks';
import { getCommunityPagesForCommunity } from 'selectors/pages';
import colors from 'constants/colors';
import { TopIssueCard, TopIssueCardIssue } from './TopIssueCard';
import { flattenPagesByType } from 'views/Pages/utils';

export const TopIssues = () => {
  const form = useForm();
  const { allPagesByType } = useAppSelector(getCommunityPagesForCommunity);
  const setPages = form.getState().values?.set_pages;
  const setPagesKeys =
    typeof setPages === 'object' && setPages !== null ? Object.keys(setPages) : [];

  const allPagesFlat = flattenPagesByType(allPagesByType);

  const issues: TopIssueCardIssue[] = setPagesKeys.map(queryStr => {
    const page = allPagesFlat.find(p => p.query_str === queryStr);
    if (page) {
      return page as TopIssueCardIssue;
    }
    return { value: queryStr, page_category: 'TOP ISSUE' } as TopIssueCardIssue;
  });

  const values = form.getState().values as Record<string, unknown>;
  const primaryColor = (values.primary_color as string) || colors.inkBlue;
  const edgeColor = (values.edge_color as string) || colors.inkBlue;
  const ctaColor = (values.cta_color as string) || colors.oathBlue;
  const tertiaryColor = (values.tertiary_color as string) || colors.oathBlue;
  const cardHelperText = (values.card_helper_text as string) || 'WHY THIS MATTERS';
  const cardRaisedAlt = (values.card_raised_alt as string) || 'Raised';
  const cardGoalAlt = (values.card_goal_alt as string) || 'Goal';

  return (
    <div className="top-issues-container">
      <div className="top-issues-row">
        {issues.map((issue, index) => (
          <div className="top-issue-item" key={issue.query_str ?? index}>
            <TopIssueCard
              issue={issue}
              primaryColor={primaryColor}
              edgeColor={edgeColor}
              ctaColor={ctaColor}
              tertiaryColor={tertiaryColor}
              cardHelperText={cardHelperText}
              cardRaisedAlt={cardRaisedAlt}
              cardGoalAlt={cardGoalAlt}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
